import { FormattedMessage, defineMessage } from 'react-intl';

import { Link } from '@sorare/routing';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BlockedUsers } from '@sorare/core/src/components/settings/BlockedUsers';
import { DiscoverableSetting as Discoverable } from '@sorare/core/src/components/settings/Discoverable';
import { Privacy } from '@sorare/core/src/components/settings/Privacy';
import { SettingsSection } from '@sorare/core/src/components/settings/SettingsSection';
import {
  SettingsPage,
  TITLES,
} from '@sorare/core/src/components/settings/pages';
import {
  COOKIE_POLICY,
  PRIVACY_POLICY,
} from '@sorare/core/src/constants/__generated__/routes';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';
import { navLabels } from '@sorare/core/src/lib/glossary';

import { SettingsWrapper } from 'components/settings/SettingsWrapper';

const policy = defineMessage({
  id: 'Settings.PrivacyAndSafety.Policies',
  defaultMessage: 'Policies',
});

export const PrivacyAndSafety = () => {
  const track = useEvents();
  const trackLink = (source: string) => {
    track('Click Footer link', {
      source,
    });
  };

  return (
    <SettingsWrapper pageTitle={TITLES[SettingsPage.PRIVACY_AND_SAFETY]}>
      <Vertical gap={2}>
        <BlockedUsers />
        <Privacy />
        <Discoverable />
        <SettingsSection title={policy}>
          <Link to={PRIVACY_POLICY} onClick={() => trackLink(PRIVACY_POLICY)}>
            <FormattedMessage {...navLabels.privacyPolicy} />
          </Link>
          <Link to={COOKIE_POLICY} onClick={() => trackLink(COOKIE_POLICY)}>
            <FormattedMessage {...navLabels.cookiePolicy} />
          </Link>
        </SettingsSection>
      </Vertical>
    </SettingsWrapper>
  );
};

export default PrivacyAndSafety;
